module.exports = __webpack_public_path__ + "static/media/image1.34238095.png";